import React, { useEffect, useState } from 'react';
import ErrorComponent from 'components/InPersonTraining/shared/Error';
import { Spinner } from 'ui/index';
import browserServicesSingleton from './BrowserServicesSingleton';

export default function withBrowserServices(WrappedComponent) {
  return function WrappedWithBrowserServices({
    hocOptions = {},
    ...remainingProps
  }) {
    const { Loading = Spinner, Error = ErrorComponent } = hocOptions;
    const [loading, setLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
      async function initialize() {
        const isLoading = browserServicesSingleton.getLoading();
        if (isLoading) {
          setTimeout(() => initialize(), 1000);
          return;
        }
        const isSingletonError = browserServicesSingleton.getIsError();
        if (isSingletonError) {
          setIsError(isSingletonError);
        }
        setLoading(false);
      }

      initialize();
    }, []);

    if (loading) {
      return <Loading />;
    }

    if (isError) {
      return <Error />;
    }

    return <WrappedComponent {...remainingProps} />;
  };
}
